/* eslint-disable react/no-multi-comp, max-len */
import React from 'react'
import { FormattedMessage } from 'react-intl'

import styles from './components/WGCWXShopCard/WGCWXShopCard.scss'


export const PERSONAL_BONUSES = (
    <FormattedMessage
        id='wgcwx_shop.personal_bonuses'
        defaultMessage='Персональные бонусы'
    />
)

export const PERSONAL_FAME_POINTS = pfp => (
    <FormattedMessage
        id='wgcwx_shop.personal_fame_points'
        defaultMessage='Личные очки славы: {pfp}'
        values={{ pfp }}
    />
)

export const PERSONAL_FAME_POINTS_BONUS = pfpBonus => (
    <FormattedMessage
        id='wgcwx_shop.personal_fame_points_bonus'
        defaultMessage='Текущий бонус: {pfpBonus}'
        values={{ pfpBonus }}
    />
)

export const PURCHASE_DATETIME_END = dateTime => (
    <FormattedMessage
        id='wgcwx_shop.purchase_datetime_end'
        defaultMessage='Получение персональных бонусов будет доступно до {dateTime}'
        values={{
            dateTime: (<span className={styles.highlight}>{dateTime.format('L, LT')}</span>),
        }}
    />
)



export const YOUR_BET = bet => (
    <FormattedMessage
        id='wgcwx_shop.cards.tank.your_bet'
        defaultMessage='Ваша ставка: {bet}'
        values={{ bet }}
    />
)

export const MIN_BET = bet => (
    <FormattedMessage
        id='wgcwx_shop.cards.tank.min_bet'
        defaultMessage='Минимальная ставка в аукционе: {bet}'
        values={{ bet }}
    />
)

export const TANK_CARD_DESCRIPTION = tanks => (
    <FormattedMessage
        id='wgcwx_shop.cards.tank.description'
        defaultMessage='Призовые машины Х уровня на выбор: {tanks}'
        values={{
            tanks: (
                <span>
                    {
                        tanks.map((tank, idx) => (
                            <span key={tank.id}>
                                <span className={styles.highlight}>{tank.name}</span>
                                { (idx !== tanks.length - 1) && ', ' }
                            </span>
                        ))
                    }
                </span>
            ),
        }}
    />
)

export const TANK_CARD_SELECTION_TITLE = (
    <FormattedMessage
        id='wgcwx_shop.cards.tank.title.selection'
        defaultMessage='Призовые машины на выбор'
    />
)

export const TANK_CARD_AUCTION_TITLE = (
    <FormattedMessage
        id='wgcwx_shop.cards.tank.title.auction'
        defaultMessage='Аукцион за призовые машины'
    />
)

export const PRODUCT_ITEMS_RECEIVED = (
    <FormattedMessage
        id='wgcwx_shop.cards.product.received'
        defaultMessage='Получено:'
    />
)


export const PRICE_STARTS_FROM = price => (
    <FormattedMessage
        id='wgcwx_shop.cards.product.price'
        defaultMessage='от {price}'
        values={{ price }}
    />
)

export const PFP_BATTLES_BONUS_SECTION = (
    <FormattedMessage
        id='wgcwx_shop.sections.pfp_battles'
        defaultMessage='Бонусы к личным очкам славы'
    />
)

export const PREMIUM_BONUSES_SECTION = (
    <FormattedMessage
        id='wgcwx_shop.sections.premium_bonuses'
        defaultMessage='Призовые бонусы'
    />
)

export const GO_TO_GLOBAL_MAP = (
    <FormattedMessage
        id='wgcwx_shop.go_to_global_map'
        defaultMessage='Перейти к карте'
    />
)

export const GLOBAL_MAP_EVENT_NAME = eventName => (
    <FormattedMessage
        id='wgcwx_shop.global_map_event_name'
        defaultMessage='Глобальная карта: "{eventName}".'
        values={{ eventName }}
    />
)



// WEBPACK FOOTER //
// ./containers/WGCWXShop/containers/WGCWXShopProducts/translations.jsx